import React from 'react'
import PropTypes from 'prop-types'
import ActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import { Link, useHistory } from 'react-router-dom'
import st from './Document.module.scss'
import documentImg from 'components/UI/icons/applications/doc.png'
import modalStore from 'Stores/modalStore'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'

const Document = ({
  data,
  listMenu,
  docType,
  modalInfo,
  documentInfo,
  confirmField,
  userNameField,
  showActionMenu,
}) => {
  const history = useHistory()

  const action = (action) => {
    switch (action) {
      case 'edit_template':
        history.push(`${documentInfo.baseLink}/constructor/${data.id}`)
        break
      case 'send_to_user':
        const ms = {
          link: modalInfo.requestLink,
          button: 'Отправить документ',
          title: modalInfo.title,
          type: 'SendDocsToUser',
          active_inputs: ['text', 'textarea'],
          data: 'media',
          fieldName: modalInfo.fieldName.user,
          fieldLink: modalInfo.link,
          pl_text: 'Имя документа',
          name_text: 'title',
          user: documentInfo.user,
          pl_textarea_tags: 'Комментарий',
          name_textarea_tags: 'description',
        }
        const md = {
          [modalInfo.fieldName.temtlate]: data.id,
          client: [],
          name: data.name,
        }
        modalStore.activity(ms, md)
        break
      default:
        break
    }
  }

  return (
    <div className={`${st.book} ${docType === 'template' && st.template}`}>
      <Link
        to={
          docType === 'template'
            ? `${documentInfo.baseLink}/viewer/template/${data.id}`
            : `${documentInfo.baseLink}/viewer/contract/${data.id}`
        }
      >
        <div className={st.wrapper_img}>
          <img className={st.img} src={documentImg} alt='' />
        </div>
      </Link>

      <div className={st.footer}>
        <div>
          <div className={st.params}>
            <div className={st.name}>
              <div className={st.name_app}>{data.name}</div>
              {data[userNameField] && (
                <div className={st.name_client}>{data[userNameField]}</div>
              )}
            </div>
            {docType !== 'template' && (
              <div className={st.dateContainer}>
                Дата подписания:{' '}
                {data[confirmField] ? (
                  <span className={st.date}>{data.signed_date}</span>
                ) : (
                  '-'
                )}
              </div>
            )}
            {docType !== 'template' && (
              <div className={st.statusContainer}>
                Status:{' '}
                <span
                  className={st.status}
                  style={{
                    color: data[confirmField]
                      ? 'var(--color-success-1)'
                      : 'var(--color-danger-1)',
                  }}
                >
                  {data[confirmField] ? 'Подписан' : 'Не подписан'}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={st.actions}>
          <SuperButton
            className={st.open}
            variant='open'
            onClick={() =>
              history.push(
                docType === 'template'
                  ? `${documentInfo.baseLink}/viewer/template/${data.id}`
                  : `${documentInfo.baseLink}/viewer/contract/${data.id}`,
              )
            }
          >
            Open
          </SuperButton>
          <SuperButton
            variant='download'
            onClick={() =>
              history.push(
                docType === 'template'
                  ? `${documentInfo.baseLink}/viewer/template-print/${data.id}`
                  : `${documentInfo.baseLink}/viewer/print/${data.id}`,
              )
            }
          />
          {showActionMenu && (
            <ActionMenu menu={listMenu} action={action} view='new' />
          )}
        </div>
      </div>
    </div>
  )
}

Document.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Document
